// extracted by mini-css-extract-plugin
export default {"container":"SponsorContactsTable_container__rXhKc","linkedinIcon":"SponsorContactsTable_linkedinIcon__GNznf"};